var angular = require('angular');
var moment = require('moment');

var util = require('./util');
var Delivery = require('./delivery');
var File = require('./file');

function Customer(customer) {
  angular.extend(this, customer);
  this.updateDeliveryEstimate(customer);
  this.fileId = this.fileId || File.individual.id;
  this.fullAddress = fullAddress(this);
  this.latitude = this.latitude || null;
  this.longitude = this.longitude || null;
  this.description = this.description && this.description.replace(/\\n/g, '\n');
  this.deliveries = (this.deliveries || [])
    .map(function(delivery) {
      return new Delivery(delivery, this);
    }, this)
    .sort(function(d1, d2) {
      return d1.product.localeCompare(d2.product);
    });
  this.notifications = (this.notifications || []);
  this.callLogs = (this.callLogs || []);
}

function fullAddress(customer) {
  // TODO handle missing values
  return customer.address + ', ' + customer.zipAndCity();
}

Customer.prototype.deliveryCount = function() {
  return this.deliveries.filter(function(delivery) {
    return delivery.deliveryStatus !== 11; // CANCELLED
  }).length;
};

Customer.prototype.hasReceivedComingSms = function() {
  var received = false;
  if(this.notifications.length != 0 ) {
      this.notifications.forEach(function(notification) {
          if(notification.isComingNotification && this.routeId === notification.routeId) {
              received = true;
          }
      }, this);
  }

  return received;
};

Customer.prototype.zipAndCity = function() {
  return util.formatZip(this.zip, this.country) + ' ' + this.city;
};

Customer.prototype.findDelivery = function(deliveryId) {
  return this.deliveries.filter(function(delivery) {
    return delivery.id === deliveryId;
  })[0];
};

Customer.prototype.findDeliveries = function(status) {
  return this.deliveries.filter(function(delivery) {
    return delivery.status === status;
  });
};

Customer.prototype.filterDeliveries = function(status, delayed) {
  return this.deliveries.filter(function(delivery) {
    return (! status || delivery.status === status) &&
           (! delayed || delivery.delayed());
  });
};

Customer.prototype.delayed = function() {
  return this.deliveries.some(function(delivery) {
    return delivery.delayed();
  });
};

Customer.prototype.estimateOutsideDeliveryWindow = function() {
  if (! this.estimatedTimestampDone || ! this.deliveryWindow()) return;

  var tooEarly = moment(this.estimatedTimestampDone).isBefore(this.deliveryWindowStart);
  var tooLate = moment(this.estimatedTimestampDone).isAfter(this.deliveryWindowStop);

  if (tooEarly || tooLate) {
    return true;
  }
};

Customer.prototype.outsideDeliveryWindow = function(start, stop) {
  if (start && this.deliveryWindowStop && moment(this.deliveryWindowStop).isSameOrBefore(start)) {
    return true;
  }
  if (stop && this.deliveryWindowStart && moment(this.deliveryWindowStart).isSameOrAfter(stop)) {
    return true;
  }
};

Customer.prototype.notCancelled = function() {
  return this.deliveries.some(function(delivery) {
    return delivery.notCancelled();
  });
};

Customer.prototype.allCancelled = function() {
  return this.deliveries.every(function(delivery) {
    return delivery.status === 'cancelled';
  });
};

// Customer has at least ONE deviation and NONE delivered and NONE unaccounted for
Customer.prototype.allDeviationOrCancelled = function() {
  return this.anyDeviations() && this.deliveries.every(function(delivery) {
    return delivery.status === 'deviation' || delivery.status === 'cancelled';
  });
};

Customer.prototype.allDelivered = function() {
  if (! this.notCancelled()) return false; // All cancelled - none have been handled by driver

  return this.deliveries.every(function(delivery) {
    return delivery.allDelivered() || ! delivery.notCancelled();
  });
};

Customer.prototype.anyDelivered = function() {
  return this.deliveries.some(function(delivery) {
    return delivery.status === 'delivered' || delivery.status === 'partiallyDelivered';
  });
};

Customer.prototype.anyDeliveries = function() {
  return this.deliveries.some(function(delivery) {
    return delivery.notCancelled();
  });
};

Customer.prototype.anyDeviations = function() {
  return this.deliveries.some(function(delivery) {
    return delivery.status === 'deviation';
  });
};

Customer.prototype.anyUnAccountedDeliveries = function() {
  return this.deliveries.some(function(delivery) {
    return (delivery.deliveryStatus === 0 || delivery.deliveryStatus === 6);
  });
};

Customer.prototype.anyProductCounts = function() {
  return this.deliveries.some(function(delivery) {
    return delivery.productCount > 1;
  });
};

Customer.prototype.deliveryStatusTimestamp = function() {
  var timestamp = 0;

  this.deliveries.forEach(function(delivery) {
    if (delivery.showStatus() && delivery.statusTimestamp > timestamp) {
      timestamp = delivery.statusTimestamp;
    }
  });

  return timestamp || undefined;
};

Customer.prototype.updateDeliveryEstimate = function(data) {
  this.estimatedTimestampDone = util.toDate(data.estimatedTimestampDone);
};

Customer.prototype.updateRouteSequence = function(data) {
  this.routeSequence = data.routeSequence;
};

Customer.prototype.deliveryWindow = function() {
  if (this.deliveryWindowStart || this.deliveryWindowStop) {
    var start = this.deliveryWindowStart ? moment(this.deliveryWindowStart).format('HH:mm') : '';
    var stop = this.deliveryWindowStop ? moment(this.deliveryWindowStop).format('HH:mm') : '';
    return start + '-' + stop;
  }
};

Customer.prototype.editable = function() {
  return this.fileId === File.individual.id;
};

Customer.prototype.deletable = function(routePlanHasRoutes) {
  return this.editable() && ! routePlanHasRoutes && this.id;
};

Customer.prototype.cancellable = function(routePlanHasRoutes, cancelled) {
  return (! this.editable() || routePlanHasRoutes) && this.id && ! cancelled;
};

Customer.prototype.editClone = function() {
  var customer = {
    deliveries: this.deliveries.map(function(delivery) {
      return delivery.editClone();
    })
  };

  var props = ['id', 'routePlanId', 'fileId', 'customerSystemId', 'orderId', 'name', 'co', 'phone1', 'phone2',
               'deliveryWindowStart', 'deliveryWindowStop', 'duration', 'address', 'zip', 'city',
               'country', 'latitude', 'longitude', 'deliveryPointId', 'transportPointId',
               'editable', 'deletable', 'cancellable', 'findDelivery', 'anyProductCounts', 'description', 'imageUrl', 'suggestedRoute', 'routeId', 'stopLocationId'];

  props.forEach(function(prop) {
    customer[prop] = this[prop];
  }, this);

  return customer;
};

module.exports = Customer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/customer.js
 ** module id = 9
 ** module chunks = 1
 **/